import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=f0961298&scoped=true&"
import script from "./Programs.vue?vue&type=script&lang=js&"
export * from "./Programs.vue?vue&type=script&lang=js&"
import style0 from "./Programs.vue?vue&type=style&index=0&id=f0961298&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0961298",
  null
  
)

export default component.exports